export const BASE_API_URL = process.env.REACT_APP_API_URL_PORT
export const SOCKET_API_URL = process.env.REACT_APP_SOCKET_URL
export const IMAGE_API_URL = process.env.REACT_APP_IMAGE_URL
export const SYNCHRO_OUT_API_URL = process.env.REACT_APP_SYNCHRO_OUT_URL
export const REACT_APP_SYNCHRO_SOCKET_COACH_URL = process.env.REACT_APP_SYNCHRO_SOCKET_COACH_URL